import OTestPush from './index.vue';

OTestPush.install = app => {
  app.component(OTestPush.name, OTestPush);
};

export default OTestPush;
